export default "__VITE_ASSET__DVSZRwOt__"